import { h, Component} from 'preact';
import { Link } from 'preact-router/match';
import { Router } from 'preact-router';
import { Text } from 'preact-i18n';
import { observer } from 'mobx-preact';
import store from '../../store'

@observer
class Header extends Component {
	render(props) {
		let prefix = '/'+store.lang;
		let darkLogo = store.activePage=='/internet' || store.activePage=='/profile' || store.activePage=='/startups';
		return (<header id="header">
					<div class="top">
						<div class="container wide">
							<ul class="contacts">
								<li><a href="tel:+37169999999">+371-69-999-999</a></li>
								<li><a href="mailto:atbalsts@dolphnet.lv" class="email">atbalsts@dolphnet.lv</a></li>
							</ul>
							<ul class="language-switcher">
								{store.langs.map(lang=><li class={store.lang==lang?"active":''}><Link href={"/"+lang+store.redirectTo}>{lang.toUpperCase()}</Link></li>)}
							</ul>
							<div class="actions">
								{store.loggedIn ?
										<Link href={prefix+"/profile"} class="profile"><Text id="header.links.cabinet"/></Link>
										: <a onClick={()=>store.showModal('login')} class="profile"><Text id="header.links.cabinet"/></a>}
								<Link href={prefix+"/availability"} class="apply"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xlinkhref="/assets/img/icons.svg#rocket"></use></svg><Text id="header.links.availability"/></Link>
							</div>
						</div>
					</div>
					<div class={(store.sticky&&!store.hideMenu?'main sticky':'main')} ref={props.mainRef}>
						<div class="container wide">
							<Link href={prefix} class="logo">
								<img src={darkLogo?"/assets/img/logo2.svg":"/assets/img/logo.svg"} alt="DolphNet Internet"/>
								<img src="/assets/img/logo-scroll.svg" alt="DolphNet Internet"/>
								<span><Text id="header.links.biznes.text"/><br/> <Text id="header.links.biznes.text2"/></span>
							</Link>
							<Link href={prefix+"/availability"} class="apply"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xlinkhref="/assets/img/icons.svg#rocket"></use></svg><Text id="header.links.availability"/></Link>
							<nav id="nav" style={store.hideMenu ? 'display:none' : ''}>
								<a onClick={()=>{
									store.toggleMenu();
								}} class="menu-trigger"></a>
								<ul class={"main-menu"+(store.mobileMenu?' active':'')}>
									<li class="speedometer"><Link activeClassName="active" href={prefix+"/internet"}><Text id="header.menu.item"/></Link></li>
									<li><Link activeClassName="active" href={prefix+"/telephone"}><Text id="header.menu.item2"/></Link></li>
									<li><Link activeClassName="active" href={prefix+"/services"}><Text id="header.menu.item3"/></Link></li>
									<li><Link activeClassName="active" href={prefix+"/support"}><Text id="header.menu.item4"/></Link></li>
								</ul>
							</nav>
						</div>
					</div>
				</header>
			// <header class={style.header}>
			// 	<h1>Preact App</h1>
			// 	<nav>
			// 		<Link activeClassName={style.active} href="/">Home</Link>
			// 		<Link activeClassName={style.active} href="/profile">Me</Link>
			// 		<Link activeClassName={style.active} href="/profile/john">John</Link>
			// 	</nav>
			// </header>
		);
	}
};

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js